import { sdk } from '@/sdk/CommercetoolsSDK';
import { ShippingAddressUpdatePayload } from '@shared/types/cart/Checkout';

export class CheckoutService {
    public async details({ currency, businessUnitKey }: { currency: string, businessUnitKey: string }): Promise<any> {
        try {
            const extensions = sdk.composableCommerce;
            const response = await extensions.checkoutReview.details({
                "currency": currency,
                "companyKey": businessUnitKey
            });
            return response.data;
        } catch (e) {
            return null;
        }
    }

    public async orderDetails({ orderNumber }: { orderNumber: any }): Promise<any> {
        try {
            const extensions = sdk.composableCommerce;
            const response = await extensions.checkoutReview.orderDetails({
                orderNumber
            });
            return response.data;
        } catch (e) {
            return null;
        }
    }

    public async updateShipmentdetails(payload: ShippingAddressUpdatePayload): Promise<any> {
        try {
            const extensions = sdk.composableCommerce;
            const response = await extensions.checkoutReview.updateShipmentDetails(payload);
            return response.data;
        } catch (e) {
            return null;
        }
    }
}
const checkoutservice = new CheckoutService();

export default checkoutservice;
